import {FEATURE_FLAGS} from '@packages/systems/feature-config/shared';
import {z} from 'zod';
import {defineToolRegistryManifest} from '../../types/base-tool-types';
import {readInstructionPathZod} from './schemas';

const toolName = 'read-instruction' as const;

const argumentZod = z.object({
  path: readInstructionPathZod.describe(
    'The relative path of the instruction file to read. Examples: rules/brand.md, brand-guidelines/SKILL.md, brand-guidelines/notes.md, wf/system-skill/SKILL.md'
  ),
  resolveReferences: z
    .boolean()
    .default(true)
    .describe(
      'Defaults to true. For rules, expands {{wf-ref:type:id}} tokens into a text representation of referenced object, appended to the returned markdown. For skills, appends a section containing file paths pointing to generated read-only reference files.'
    ),
});

export const readInstructionManifest = defineToolRegistryManifest({
  id: toolName,
  prettyName: 'Read instruction',
  llmTool: {
    name: toolName,
    description:
      'Reads the full markdown content for one site-authored agent skill or rule. Use search-instructions first when you do not already know the instruction path.',
    inputSchema: argumentZod,
  },
  type: 'server',
  featureGate: FEATURE_FLAGS.AGENT_INSTRUCTIONS,
  permission: [{resource: 'SiteAgentInstructions', action: 'read'}],
  confirmBeforeExecuting: false,
});

export type ReadInstructionArgumentType = z.infer<typeof argumentZod>;
